<template>
  <div class="container-md">
    <div class="row justify-content-center body">
      <div class="col-auto px-5">
        <div class="py-3 text-center">
          <h3>{{ $t("reset.resetResult") }}</h3>
        </div>
        <div class="d-grid gap-2 p-2 mt-2">
            <button type="submit" class="btn btn-primary" :disabled="isButtonDisabled" @click="login">{{ $t("signUpResult.submit") }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      isButtonDisabled: false
    }
  },
  methods: {
    login() {
      this.isButtonDisabled = true
      this.$router.push({ name: "login"})
    }
  },
}
</script>

<style scoped>
.body {
  height: 100%;
  padding-top:128px;
}
</style>
